import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';

@Component({
	selector: 'rx-intuitive-order-layout',
	templateUrl: './rx-intuitive-order-layout.component.html',
	styleUrls: ['./rx-intuitive-order-layout.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TlkCardComponent]
})
export class RxIntuitiveOrderLayoutComponent {}
